import Axios from 'axios'

const webSocketPrint = {
  axios () {
    let AxiosInstance = Axios
    AxiosInstance.defaults.baseURL = process.env.BACKEND_URL
    return AxiosInstance
  },

  getBarcode(params) {
    return this.axios().post('/order/barcode', params)
  },

  getAOLWSBarcode(params) {
    return this.axios().post('/order/barcode/aolws', params)
  },

  readBarcode(barcode) {
    return this.axios().post(`/order/barcode/read?barcode=${barcode}`)
  }
}

export default webSocketPrint
